<ng-sidebar-container>
  <div ng-sidebar-content>
    <ngx-page-container>
      <h1>Open Sample Requests</h1>
      <hr>


      <div style="margin-left:1em;min-width:35em">
        <label><b>Filter</b></label>
        <div class="row ml-1">
          <div style="width:25em">
            <ngx-doc-form-multiselect [(value)]="filter.issuer" [options]="issuerOptions" [multi]="false" placeholder="Select Issuer(s)"></ngx-doc-form-multiselect>
            <ngx-doc-form-multiselect [(value)]="filter.country" [options]="countryOptions" placeholder="Select Country"></ngx-doc-form-multiselect>
            <ngx-doc-form-multiselect [(value)]="filter.manager" [options]="employeeOptions" [multi]="false" placeholder="Select Manager"></ngx-doc-form-multiselect>
          </div>
          <div style="width: 42em">
            <ngx-doc-form-multiselect [(value)]="filter.customers" [options]="data.businessOptions" (valueChange)="customersChanged($event)"
              [checkbox]="true" [maxSelectedItems]="3" placeholder="Select customer(s)">
            </ngx-doc-form-multiselect>
            <ngx-doc-form-multiselect *ngIf="filter.customers?.length" [(value)]="filter.customerDocumentNumbers" [checkbox]="true"
              [options]="customerReferenceOptions" placeholder="Customer reference(s)">
            </ngx-doc-form-multiselect>

            <ngx-doc-form-multiselect *ngIf="filter.businessUnits" [(value)]="filter.businessUnits" [options]="data.businessUnitOptions"
              [checkbox]="true" placeholder="Select business unit(s)">
            </ngx-doc-form-multiselect>

            <!-- <div class="row" style="margin:2pt;">
              <div style="padding:4pt">Project Number:</div>
              <div style="width:75%"><ngx-form-text [(value)]="filter.projectNumber"></ngx-form-text></div>
            </div> -->
          </div>
        </div>

        <div class="mt-4" style="max-width:57em">
          <ngx-form-multi-select [checkbox]="true" title="Select Finished Products" [businessId]="finishedProductBusinessId" [mode]="'column-select'" [(value)]="filter.finishedProducts" [options]="data.finishedProductOptions">
          </ngx-form-multi-select>
        </div>

        <div class="mt-4" style="max-width:57em">
          <ngx-doc-form-filter-select title="Sort By" [noBorder]="true" [(value)]="filter.sortDate" [options]="datesData.getSrOptions()"></ngx-doc-form-filter-select>
        </div>

        <div class="row mt-4 ml-1">
          <div>SR Status Filter:</div>
          <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <ngx-doc-form-checkbox [(value)]="filter.srStatus[0]" label="Default"></ngx-doc-form-checkbox> -->
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <ngx-doc-form-checkbox [(value)]="filter.srStatus[1]" label="Factory"></ngx-doc-form-checkbox>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <ngx-doc-form-checkbox [(value)]="filter.srStatus[4]" label="EU Warehouse"></ngx-doc-form-checkbox>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <ngx-doc-form-checkbox [(value)]="filter.srStatus[2]" label="Customer"></ngx-doc-form-checkbox>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <ngx-doc-form-checkbox [(value)]="filter.srStatus[3]" label="Completed"></ngx-doc-form-checkbox>
        </div>

        <div class="row mt-4 ml-1">
          <div>Production Site:</div>
          <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <ngx-doc-form-checkbox [(value)]="filter.manufacturer[0]" label="All"></ngx-doc-form-checkbox> -->
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <ngx-doc-form-checkbox [(value)]="filter.manufacturer[1]" label="NRT"></ngx-doc-form-checkbox>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <ngx-doc-form-checkbox [(value)]="filter.manufacturer[2]" label="NRKV"></ngx-doc-form-checkbox>
        </div>

        <div class="row mt-4 ml-1">
          <div class="mr-2">Reverse Sort Order:</div>
          <ngx-doc-form-checkbox [(value)]="filter.reverseSort"></ngx-doc-form-checkbox>
        </div>

      </div>

      <br><br>

      <!-- <div class="row">
        <div class="col-md-4">Variant</div>
        <div class="col-md-8">
          <nb-radio-group name="ocmachinery" class="row col-md-8" [(ngModel)]="filter.variant">
            <nb-radio [value]="401">OC Machinery by Manager</nb-radio>
            <nb-radio [value]="402">OC Machinery</nb-radio>
          </nb-radio-group>
        </div>
      </div> -->

      <!-- <div class="row">
        <div class="col-md-4"></div>
        <div class="col-md-8 row">
          <div class="ml-3"><ngx-doc-form-checkbox [(value)]="filter.projectOverview"></ngx-doc-form-checkbox></div>
          <div>change for project overview</div>
        </div>
      </div> -->

      <div class="mt-4">
        <button class="nrk-button" (click)="deliveryStatusXls()" [disabled]="xlsLoading">Delivery Status XLSX</button>
      </div>

      <div class="mt-4">
        <button class="nrk-button" (click)="deliveryStatusXls(1)" [disabled]="xlsLoading">Tech Project Delivery Status XLSX</button>
      </div>

      <!-- <div class="mt-4">
        <button class="nrk-button" (click)="documentXls()" [disabled]="loading">Download XLSX</button>
      </div> -->

      <br>
      <div>
        <button class="btn btn-info btn-lg" (click)="reload()">Apply Filter</button>
      </div>
      <br>

      <!-- <ngx-reports-printer #xlsPrinter *ngIf="search" [search]="search" style="display:none" [reverse]="reverseSort" [pdfSidebar]="false" [printCount]="true" [messaging]="true" [noheader]="true" (done)="reportLoaded()"></ngx-reports-printer> -->
      <ngx-reports-printer #reportsPrinter *ngIf="search" [search]="search" [pdfSidebar]="true" [printCount]="true" [messaging]="true" [noheader]="true" (done)="reportLoaded()"></ngx-reports-printer>
      <ngx-reports-printer #deliveryXlsPrinter *ngIf="xlsSearch" style="display:none" [search]="xlsSearch" [pdfSidebar]="false" [printCount]="true" [messaging]="true" [noheader]="true" (done)="xlsLoaded()"></ngx-reports-printer>

    </ngx-page-container>
  </div>
</ng-sidebar-container>

